import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Tooltip, Typography, message } from "antd";
import { saveAs } from "file-saver";

import { dateTimeFormatter, DATE_TIME_FILTERS_FORMAT } from "../../utils/date";
import { PRIMARY_600, GRAY_700 } from "../../constant/colors";
import { ExportOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { exportTasksReportAPI } from "../../api/api";
import LoadingIcon from "../ExportButton/LoadingIcon";
import { UNASSIGNED } from "../../constant/filters";
import { fontWeights, sizes } from "../../constant/styles";
const { Text } = Typography;

const StyledButton = styled(Button)`
  background: unset;

  :active,
  :hover {
    background: unset;
  }

  :disabled {
    pointer-events: none;
    opacity: 1;
  }
`;

const downloadFile = (blob, fileName) => {
  const fileBlob = new Blob([blob.data], { type: blob.headers["content-type"] });
  saveAs(fileBlob, fileName);
};

const ExportTasksData = ({ filterData }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const getReportData = async () => {
    const filters = {
      assignee: filterData.assignees === UNASSIGNED ? "" : filterData.assignees,
      status: filterData.status,
      dueDate: filterData?.dueDate?.start
        ? { start: filterData.dueDate.start, end: filterData.dueDate.end }
        : filterData.period
    };

    setIsLoading(true);
    try {
      const blob = await exportTasksReportAPI(filters);
      const fileName = `${t("patientsTasks.export.fileNamePrefix")}_[${dateTimeFormatter(
        new Date(),
        DATE_TIME_FILTERS_FORMAT
      )}]`;
      downloadFile(blob, fileName);
    } catch {
      message.error(t("patientsTasks.export.export_failed"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Tooltip
      title={
        <Text style={{ color: GRAY_700, fontSize: sizes.small, fontWeight: fontWeights.semibold }}>
          {t("patientsTasks.export.download_tasks")}
        </Text>
      }
      color={"white"}
      placement="right"
    >
      <StyledButton
        id="export_tasks_button"
        type="text"
        disabled={isLoading}
        onClick={() => {
          getReportData();
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {!isLoading ? (
            <ExportOutlined style={{ color: PRIMARY_600 }} />
          ) : (
            <LoadingIcon color={PRIMARY_600} size={16} />
          )}
        </div>
      </StyledButton>
    </Tooltip>
  );
};

export default ExportTasksData;
